import React, { FC, Fragment } from 'react';
import { Notification } from 'models/notification';

type NotificationSubjectProps = {
    notification: Notification;
};

const NotificationSubject: FC<NotificationSubjectProps> = ({ notification }: NotificationSubjectProps) => {
    const extraInfo = () => {
        if (notification.messageData.extraInfo) {
            const info = notification.messageData.extraInfo;
            if (info.length > 190) {
                return ` - ${info.substring(0, 190)}...`;
            }
            return ` - ${info}`;
        }
        return undefined;
    };

    return (
        <Fragment>
            {notification.messageData.messageInfo}
            {extraInfo()}
        </Fragment>
    );
};

export default NotificationSubject;
